function Footer() {
    return(
        <div>
            <div className="hidden-xs" id='footer'>
                
            </div>
            {/* mobile footer text */}
            <div className="visible-xs" id='footer-sm'>
                
            </div>
        </div>
    )
}

export default Footer;